import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { GuryouApiConfig } from '@guryou/api-client';
import { trainingApi } from '@guryou/api-client-gql';
import { LOGOUT } from '@guryou/redux';
import App from 'App';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'store';

import './i18n';

import './tailwind.css';

/* rest */

const getAccessToken = async () => {
  try {
    const session = await fetchAuthSession();

    const token = session.tokens?.idToken?.toString();

    return token ? { Authorization: token } : {};
  } catch (error) {
    return {};
  }
};

GuryouApiConfig.getApiEndpoint = () => process.env.REACT_APP_WAAS_API_ENDPOINT;
GuryouApiConfig.getProxyApiEndpoint = () => process.env.REACT_APP_GRAPHQL_URL;
GuryouApiConfig.getAccessToken = getAccessToken;

const awsConfig = {
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_GRAPHQL_URL,
      region: process.env.REACT_APP_AWS_PROJECT_REGION,
      defaultAuthMode: 'userPool',
    },
  },
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
      region: process.env.REACT_APP_AWS_COGNITO_REGION,
    },
  },
};

Amplify.configure(awsConfig);

// The one real "session is dead" signal: Amplify could not refresh the tokens (refresh token
// expired or revoked). Route guards no longer judge expiry themselves (#1855).
Hub.listen('auth', ({ payload }) => {
  if (payload.event === 'tokenRefresh_failure') {
    store.dispatch({ type: LOGOUT });
  }
});

// Amplify holds a single GraphQL endpoint — api/proxy's (REACT_APP_GRAPHQL_URL above), which every
// generated client falls back to. api/training is a SECOND API behind its own gateway, so its
// generated client has to be pointed at it explicitly or every training call lands on the proxy,
// which has no such resolvers. See #1658.
trainingApi.configureClient({ endpoint: process.env.REACT_APP_TRAINING_API_URL });

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
